import { Component, OnInit, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '../../../services/users/users.service';

@Component({
  selector: 'app-delete-user-modal',
  templateUrl: './delete-user-modal.component.html',
  styleUrls: ['./delete-user-modal.component.scss'],
})
export class DeleteUserModalComponent implements OnInit {
  @Input() user: any;
  constructor(
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private UsersService: UsersService
  ) {}

  ngOnInit(): void {}

  close() {
    this.modalService.dismissAll();
  }

  delete() {
    this.SpinnerService.show();
    this.UsersService.deleteUser(this.user.id)
      .then((res) => {
        this.SpinnerService.hide();
        let response = JSON.parse(JSON.stringify(res));
        if (response.success) {
          this.close();
          this.toastr.success('User deleted');
        } else {
          this.toastr.error('User not deleted');
        }
      })
      .catch(() => {
        this.close();
        this.toastr.error('User not deleted');
        this.SpinnerService.hide();
      });
  }
}
